import { isMobileDevice } from './device';

export function mobileLoader() {
    const isMobile = isMobileDevice();
    if (!isMobile) {
        return Response.redirect("/", 302); // מפנה אוטומטית לדף הראשי אם זה לא מובייל
    }
    return null; // אם המשתמש במובייל, ממשיכים כרגיל
}

export function desktopLoader() {
    const isMobile = isMobileDevice();

    // אם המשתמש במובייל, נוודא שהוא יגיע לגרסה של המובייל
    if (isMobile) {
        return Response.redirect("/Mobile", 302); // הפנייה לדף הראשי של הדסקטופ
    }
    return null
}

export function desktopregistrationTrainingDaysLoader({request}) {
    const isMobile = isMobileDevice();

      const url = new URL(request.url);

   const qid = url?.searchParams.get("qId");     // "credits"
  const pid = url?.searchParams.get("pId");   // "2"
    // const corseId = params?.corseId ? `/${params.corseId}` : "";
    // const corseId = params?.corseId? +params.corseId : "";
    // console.log(params)
    // אם המשתמש במובייל, נוודא שהוא יגיע לגרסה של המובייל
    if (isMobile) {
        // const currentUrl = window.location.pathname;
        // const corseId = currentUrl.split('/).pop();
        return Response.redirect(`/Mobile?${qid?`qId=${qid}`:""}${pid?`pId=${pid}`:""}`, 302); // הפנייה לדף הראשי של הדסקטופ
    }
    if(Number.isInteger(qid) || Number.isInteger(pid))
        return Response.redirect(`/registrationTrainingDays`, 302);
return null
}
// export function desktopregistrationTrainingDaysLoader({params}) {
//     const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
//     // const corseId = params?.corseId ? `/${params.corseId}` : "";
//     const corseId = params?.corseId? +params.corseId : "";
//     // console.log(params)
//     // אם המשתמש במובייל, נוודא שהוא יגיע לגרסה של המובייל
//     if (isMobile) {
//         // const currentUrl = window.location.pathname;
//         // const corseId = currentUrl.split('/').pop();
//         return Response.redirect(`/Mobile${Nu'mber.isInteger(+corseId)?"/"+corseId:''}`, 302); // הפנייה לדף הראשי של הדסקטופ
//     }
//     if(!Number.isInteger(corseId))
//         return Response.redirect(`/registrationTrainingDays`, 302);
// return null
// }


export function mobileregistrationTrainingDaysLoader({params}) {
    const isMobile = isMobileDevice();
    const corseId = params?.corseId? +params.corseId : "";
    // אם המשתמש במובייל, נוודא שהוא יגיע לגרסה של המובייל
    if (!isMobile) {
        const currentUrl = window.location.pathname;
        const corseId = currentUrl.split('/').pop();
        return Response.redirect(`/registrationTrainingDays/${corseId}`, 302); // הפנייה לדף הראשי של הדסקטופ
    }
    if(!Number.isInteger(corseId))
        return Response.redirect(`/Mobile`, 302);
    return null
}

export function membershipFeeLoader() {
    const isMobile = isMobileDevice();
    if (isMobile) {
        return Response.redirect("/Mobile/membership-fee", 302);
    }
    return null;
}

export function mobileMembershipFeeLoader() {
    const isMobile = isMobileDevice();
    if (!isMobile) {
        return Response.redirect("/membership-fee", 302);
    }
    return null;
}

export function aidFundLoader() {
    const isMobile = isMobileDevice();
    if (isMobile) {
        return Response.redirect("/Mobile/aid-fund", 302);
    }
    return null;
}

export function mobileAidFundLoader() {
    const isMobile = isMobileDevice();
    if (!isMobile) {
        return Response.redirect("/aid-fund", 302);
    }
    return null;
}
















      // אם זה לא מובייל, נוודא שהוא יועבר לגרסה של הדסקטופ

//   export function desktopLoader() {
//     const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

//     // אם המשתמש במובייל, נוודא שהוא יגיע לגרסה של המובייל
//     if (isMobile) {
//       return null; // אם זה מובייל, נמשיך לגרסה של המובייל
//     } else {
//       // אם זה לא מובייל, נוודא שהוא יועבר לגרסה של הדסקטופ
//       return Response.redirect("/", 302); // הפנייה לדף הראשי של הדסקטופ
//     }
//   }